<div>
  <img width="150px" src="../../../assets/sad.svg" alt="">
  موردی برای نمایش وجود ندارد!
</div>
